import { render } from "./ClassListTableRowItem.vue?vue&type=template&id=1bbd226d&scoped=true&ts=true"
import script from "./ClassListTableRowItem.vue?vue&type=script&lang=ts"
export * from "./ClassListTableRowItem.vue?vue&type=script&lang=ts"

import "./ClassListTableRowItem.vue?vue&type=style&index=0&id=1bbd226d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbd226d"]])

export default __exports__